
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/tech-tales",
      function () {
        return require("private-next-pages/blog/tech-tales.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/tech-tales"])
      });
    }
  